module.exports = __webpack_public_path__ + "img/iphones-many.4a1cebb2.png";